import React from 'react';
import { Box, Button, Grid, Stack, Typography, alpha } from '@mui/material';
import { getStoredPublicSchoolProfile } from '../../publicSchoolProfile';

const FooterShowcaseSection = ({ section, sectionKey, footerLinks, openActionPath, bodyContent }) => {
  const publicProfile = getStoredPublicSchoolProfile();
  const resolvedAddress = section.footerAddress || publicProfile.address || 'Add address in editor.';
  const resolvedPhone = section.footerPhone || publicProfile.phone || '';
  const resolvedEmail = section.footerEmail || publicProfile.email || '';

  return (
    <Box component="footer" sx={{ backgroundColor: '#0B1220', color: '#FFFFFF', py: { xs: 2.2, md: 3 }, px: { xs: 1.6, md: 2.4 }, borderTop: `1px solid ${alpha('#FFFFFF', 0.1)}` }}>
      <Stack spacing={6} sx={{ width: '100%' }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Stack spacing={2}>
              {section.title && <Typography sx={{ fontWeight: 800, fontSize: '1.5rem', letterSpacing: '-0.02em' }}>{section.title}</Typography>}
              {bodyContent && <Box sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.95rem', lineHeight: 1.7, pr: { md: 4 } }}>{bodyContent}</Box>}
            </Stack>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <Stack spacing={2}>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.4)', mb: 1 }}>Address</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.95rem', lineHeight: 1.6 }}>{resolvedAddress}</Typography>
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.4)', mb: 1 }}>Contact</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.95rem' }}>{resolvedPhone}</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.95rem' }}>{resolvedEmail}</Typography>
              </Box>
            </Stack>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography sx={{ fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.4)', mb: 2 }}>Quick Links</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {footerLinks.length ? footerLinks.map((path, index) => (
                <Button key={`${sectionKey}-link-${index}`} size="small" variant="text" onClick={() => openActionPath(path)} sx={{ color: 'rgba(255,255,255,0.8)', backgroundColor: alpha('#FFFFFF', 0.05), borderRadius: '100px', px: 2, textTransform: 'none', '&:hover': { backgroundColor: alpha('#FFFFFF', 0.15), color: '#FFFFFF' } }}>
                  {path}
                </Button>
              )) : <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem' }}>Add footer links in editor.</Typography>}
            </Box>
          </Grid>
        </Grid>
        
        {section.footerCopyright && (
          <Box sx={{ pt: 4, borderTop: `1px solid ${alpha('#FFFFFF', 0.1)}`, textAlign: { xs: 'center', md: 'left' } }}>
            <Typography sx={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>{section.footerCopyright}</Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};
export default FooterShowcaseSection;
